<icc-list
    [searchable]="true"
    [items]="shapes"
    itemTemplate="itemOnlyTitle"
    itemImgHeight="medium"
    (select)="selectShape($event)"
    [selected]="selected"
></icc-list>

